export default "__VITE_ASSET__e03d9c03__"